import {
  Flex,
  Text,
  Heading,
  Image,
  Center,
  Link,
  Box, Button, useStyleConfig,
} from '@chakra-ui/react';
import MenuList from './MenuList';
import MenuItem from './MenuItem';

import BorderBox from '../../components/Wrappers/BorderBox';
import { toggleMenu } from './utils';
import { updateSectionData } from '../../handlers/utils';
import DownloadModal from '../../components/Modal/DownloadModal';
import { FaDownload } from 'react-icons/fa';
import { openPreview } from '../../components/Preview/utils';

const Menu = ({ navSections, props, formikProps }) => {
  const stateProps = props.stateProps;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const img_src = navSections?.menu?.hero ?? '';
  if(props.stateProps.sectionData.sectionIndex !== 0 ) {
    updateSectionData({ sectionIndex: 0 }, props.stateProps);
  }
  return (
    <>
      <DownloadModal
        stateProps = {stateProps}
        />
      <Box display="flex" justifyContent="space-between" width="100%" >

        <Heading variant="section" pb={['32px', '32px', '40px']}>
          Resume Content
        </Heading>
        <Button
          variant='download'
          leftIcon={<FaDownload />}
          onClick={() => openPreview(props,stateProps.sectionData.resumeIndex)}
          sx={{...buttonStyles.download,...buttonStyles.menuDownload}}

        >
          Download
        </Button>
           </Box>
      <BorderBox>
        <Flex>
          <Center
            sx={{ width: '350px', overflow: 'hidden', margin: '0 -60px 0 0' }}
          >
            <Image
              sx={{
                width: [0, 0, '400px'],
                position: 'relative',
                objectFit: 'contain',
                left: '-25%',
                zIndex: -1,
              }}
              src={img_src}
            />
          </Center>
          <MenuList>
            <Text variant="o16" sx={{textTransform:'uppercase'}}>Recommended Sections</Text>
            {Object.entries(navSections).map(([key, value]) => {
              return (<MenuItem props={props} formikProps={formikProps} sectionTitle={value.label} sectionName={key} menu='menu' />)

            })}
            {!props.stateProps.menuExpanded && (
              <Box sx={{ padding: '24px 0 0' }}>
                <Text variant="o16">
                  Looking for volunteer experience, technical skills,
                  certifications, languages, and awards?
                </Text>
                <Link onClick={() => toggleMenu(formikProps, stateProps)}>
                  <Text
                    sx={{
                      color: 'NAVY',
                      fontWeight: 600,
                      textDecoration: 'underline',
                      padding: '0 0 35px',
                    }}
                  >
                    View additional sections here
                  </Text>
                </Link>
              </Box>
            )}
            {props.stateProps.menuExpanded && (
              <Text variant="o16" sx={{textTransform:'uppercase',paddingTop:'16px'}}>
                Additional Sections
              </Text>
            )}
            {props.stateProps.menuExpanded &&
              Object.entries(navSections).map(([key, value]) => {
                return (
                <MenuItem props={props} formikProps={formikProps} sectionTitle={value.label} sectionName={key} menu='menu-ex' />
                )
              })}
            {props.stateProps.menuExpanded && (
              <Link
                sx={{ color: 'NAVY', textDecoration: 'underline' }}
                onClick={() => toggleMenu(formikProps, stateProps)}
              >
                See fewer
              </Link>
            )}
          </MenuList>
        </Flex>
      </BorderBox>
    </>
  );
};

export default Menu;
